import { applyRestApiSplitTreatments } from './utils/backendApi/applyRestApiSplitTreatments'
import { getBackendHost } from './utils/backendApi/getBackendHost'
import { isProduction } from 'utils/envs'

import { createApi, FetchArgs, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import store from './state/store'
import { ORG_MODE_COMPATIBLE_APIS } from 'utils/constants'
import { Auth } from 'aws-amplify'

export const dynamicBaseQuery = async (args: FetchArgs, webApi, extraOptions) => {
  // adjust full url based on feature flags per route
  args.url = await applyRestApiSplitTreatments(args)
  // parse "/purchases/xml" route response as text istead of default json
  args.responseHandler = response => {
    if (
      args.url?.indexOf('/purchases/xml') > -1 ||
      args.url?.indexOf('/commodities/price-sheets/download') > -1 ||
      args.url?.match(
        /\/core-api\/commodities\/price-entries\/price-sheet\/[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}\/material-type\/[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}/,
      ) ||
      args.url?.match(
        /\/commodities\/price-sheets\/[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}\/csv/,
      ) ||
      args.url?.indexOf('/commodities/price-sheets/csv') > -1 ||
      args.url?.indexOf('/contracts/purchase-orders/csv') > -1 ||
      args.url?.indexOf('/contracts/sales-orders/csv') > -1 ||
      response.status === 204
    )
      return response.text()
    return response.json()
  }

  const currentState = store.getState()
  const { ui = {} } = currentState
  const { inOrgMode } = ui as any

  const isOrgModeRoute = ORG_MODE_COMPATIBLE_APIS.some(prefix => args.url.startsWith(prefix))

  const preSetHeaders = args.headers || {}

  const rawBaseQuery = fetchBaseQuery({
    baseUrl: getBackendHost(args.url),
    prepareHeaders: async headers => {
      const session = store.getState().auth

      // Testing an authernative way to get the session token. Hopefully this will prevent failures when starting the app with an expired token
      // This is a temporary solution until we can refactor the auth flow to handle token refreshes more gracefully
      // See
      const { token: originalToken, organization, selectedYard, yardId } = session
      let token = originalToken

      // For now, we will only use the token from the Amplify session if it is not in production env
      if (!isProduction) {
        console.log('Using new code to get token from Amplify session')
        token = (await Auth.currentSession()).getIdToken().getJwtToken()
      }

      if (token) {
        headers.set('Authorization', `Bearer ${token}`)
        headers.set('Organization', organization as any)
        headers.set('Build', __COMMIT_HASH__)

        // if a pre-set header is already set, don't override it
        if (!(preSetHeaders as any)?.yard) {
          // Here we're modifying the headers for the route if it is in org mode
          if (inOrgMode && isOrgModeRoute) {
            headers.set('Yard', 'ORG_MODE')
          } else {
            headers.set('Yard', selectedYard as any)
            headers.set('yardId', yardId as any)
          }
        }
      }
      return headers
    },
  })
  return rawBaseQuery(args, webApi, extraOptions)
}

// initialize an empty api service that we'll inject endpoints into later as needed
export const api = createApi({
  baseQuery: dynamicBaseQuery,
  endpoints: () => ({}),
})
